export default {
  itemDescriptionDefaultColor: Styles.color.loyaltyHighlight,
  itemDescriptionFontSize: '1rem',
  itemDescriptionFontWeightBold: 'bold',
  itemDescriptionLineHeight: '1.375rem',
};
